import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import { getUserHomework, userUpload } from "@/api/homework";

@Component({
    name: "ProgramItem"
})
export default class ProgramItem extends Vue {
    @Prop() readonly item!: any;
    private buyType: string = "NORMAL";
    private text: string = "";
    private id: Number = this.item.id;
    private downloadPath: string = this.item.page.downloadPath;
    private teacherAvatar: string = this.item.actorImg;
    private requireProgram: boolean = false;
    private updateUrl: string = userUpload();
    private accessToken: string = localStorage.getItem("accessToken");
    private showFile: Boolean = true;

    get userHeader(): object {
        return {
            "x-access-token": localStorage.getItem("accessToken"),
            "x-refresh-token": localStorage.getItem("refreshToken")
        };
    }
    get myData() {
        return {
            appName: "",
            courseId: this.item.courseId,
            homeworkId: this.item.homeworkId
        };
    }
    download() {
        window.open(this.downloadPath);
    }
    beforeUpload(file) {
        if (file.size > 1024 * 1024 * 50) {
            this.$message.error("上传的文件太大了！！");
        }
    }
    fileUploadSuccess(res) {
        if (res.code === 200) {
            this.$message.success("上传成功！");
        } else {
            this.$message.error(res.msg);
        }
    }
}

//@ts-ignore
export { default as ProgramItem } from "./index.vue";
